import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <rect width={16} height={16} fill={props.color || "#DAD3CC"} rx={8} />
    <path stroke="#fff" strokeWidth={2} d="m4 7 3.5 3.5 5-5" />
  </svg>
);
export default SvgComponent;
